import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M1.334 3.263a1.93 1.93 0 0 1 1.93-1.93h1.834A2 2 0 0 1 6.954 2.59l.704 1.758.046.129a2 2 0 0 1-.367 1.894l-.379.453h.001A.666.666 0 0 0 7 7.724L8.279 9a.667.667 0 0 0 .898.04l.454-.378.108-.084a2 2 0 0 1 1.915-.236l1.757.703a2 2 0 0 1 1.257 1.856v1.835a1.93 1.93 0 0 1-1.93 1.93C6.44 14.667 1.335 9.56 1.335 3.263Zm1.333 0c0 5.562 4.509 10.07 10.07 10.07.33 0 .597-.267.597-.596v-1.835a.666.666 0 0 0-.328-.574l-.09-.044-1.758-.703a.667.667 0 0 0-.6.053l-.074.053-.454.379c-.745.62-1.82.613-2.553.007l-.142-.129-1.278-1.279a2 2 0 0 1-.123-2.694l.38-.454a.667.667 0 0 0 .134-.588l-.028-.086-.703-1.757a.667.667 0 0 0-.62-.42H3.265a.596.596 0 0 0-.597.597Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "phone"}) } }